import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChange, SimpleChanges } from '@angular/core';

import { isNullOrUndefined, ImagePlaceholderDirective, SafeUrlPipe } from '@uzurv/core';
import { Document } from '../../models';
import { DriverService } from '../../services/driver';

@Directive({
    selector: 'img[dotsDocument]',
    host: {
        '(error)': 'onError()',
        '(load)': 'onLoad()',
        '[src]': 'src'
    },
    standalone: true
})
export class DocumentFileDirective extends ImagePlaceholderDirective implements OnInit, OnChanges {

  @Input()
  dotsDocument: Document;

  constructor(
    protected renderer: Renderer2,
    protected hostElement: ElementRef,
    protected driverService: DriverService,
    protected safeUrlPipe: SafeUrlPipe
  ) {
    super(renderer, hostElement);
  }

  ngOnInit() {
    this.src = this.placeholder;
    this.fetchDocumentImage();
  }

  ngOnChanges( changes: SimpleChanges ) {
    const dotsDocumentChange: SimpleChange = changes.dotsDocument;
    if (dotsDocumentChange) {
      if (isNullOrUndefined(dotsDocumentChange.currentValue)) {
        this.src = this.placeholder;
        return;
      }

      if (!dotsDocumentChange.currentValue.equals(dotsDocumentChange.previousValue)) {
        this.fetchDocumentImage();
      }
    } else {
      this.src = this.placeholder;
    }
  }

  refresh() {
    this.fetchDocumentImage();
  }

  onError() {
    super.onError();
  }

  onLoad() {
    super.onLoad();
  }

  private fetchDocumentImage() {
    if (isNullOrUndefined(this.dotsDocument)) {
      return;
    }

    this.driverService.getFileForDocumentIdAndDriverId(this.dotsDocument.id, this.dotsDocument.driverId)
      .subscribe(fileData => {
        if (!isNullOrUndefined(fileData)) {
          this.src = this.safeUrlPipe.transform(fileData.getDataURLString());
        }
      }, err => {
        this.src = this.placeholder;
      });
  }
}
